"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BasePatternFactory = _interopRequireDefault(require("../lib/BasePatternFactory"));

var _EmailAddressRegex = _interopRequireDefault(require("../regex/EmailAddressRegex"));

var _default = (0, _BasePatternFactory.default)({
  name: 'EmailAddress',
  validator: function validator(input) {
    return _EmailAddressRegex.default.test(input);
  }
});

exports.default = _default;
module.exports = exports.default;